/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum PlaybackErrorType {
    ILiveTvErrorBase = 0,
    LiveTvErrorBase,
    LiveTvLocationError,
    LiveTvPlaybackError,
    LiveTvSessionError,
}
